import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import MetricListsList from './MetricListsList'

export default function MetricLists() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/metric_lists" component={MetricListsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}